module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0015.8f37b8d7.jpg";